import { Injectable } from '@angular/core';
import Elmahio from 'elmah.io.javascript';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private logger = new Elmahio({
    apiKey: environment.elmahKey, logId: environment.elmahid
  });
  constructor() { }

  public error(message: string, details?: any) {
    this.logger.error(message, details);
  }
}